import { Monitor, Moon, Sun } from 'lucide-react';
import { useTheme, type ThemePreference } from '../lib/ThemeContext';

const OPTIONS: { value: ThemePreference; label: string; Icon: typeof Sun }[] = [
  { value: 'light', label: 'Licht', Icon: Sun },
  { value: 'dark', label: 'Donker', Icon: Moon },
  { value: 'system', label: 'Systeem', Icon: Monitor },
];

export function ThemeToggle({ className = '' }: { className?: string }) {
  const { preference, setPreference } = useTheme();

  return (
    <div
      className={`inline-flex rounded-lg border border-border bg-surface p-0.5 ${className}`}
      role="group"
      aria-label="Thema"
    >
      {OPTIONS.map(({ value, label, Icon }) => (
        <button
          key={value}
          type="button"
          title={label}
          aria-pressed={preference === value}
          onClick={() => setPreference(value)}
          className={`rounded-md p-1.5 transition-colors ${
            preference === value
              ? 'bg-primary text-white shadow-sm'
              : 'text-text-muted hover:bg-surface-card hover:text-text'
          }`}
        >
          <Icon className="h-4 w-4" aria-hidden />
          <span className="sr-only">{label}</span>
        </button>
      ))}
    </div>
  );
}
